import {
    Controller
} from "stimulus"

export default class extends Controller {
    static targets = ['trigger', 'pages']
    observer
    pageUrls
    currentPage
    totalPages
    blacklist = []
    primed = false

    get nextPage() {
        return (this.totalPages > this.currentPage) ? this.currentPage + 1 : null
    }

    get nextPageUrl() {
        return this.nextPage ? this.pageUrls[this.nextPage] : null
    }

    initialize()
    {
        this.observer = new IntersectionObserver(this.loadNextPage.bind(this), {threshold: 1.0, rootMargin: '50px'})
        this.pageUrls = JSON.parse(this.data.get('pageUrls'))
        this.currentPage = parseInt(this.data.get('currentPage'))
        this.totalPages = this.data.get('totalPages')
        this.observe()
    }

    observe()
    {
        this.observer.observe(this.triggerTarget)
    }

    unobserve()
    {
        this.observer.unobserve(this.triggerTarget)
    }

    loadNextPage()
    {
        if (!this.primed) {
            this.primed = true
            return
        }
        if (!this.nextPageUrl) {
            this.tearDown()
            return
        }

        if (this.blacklist.includes(this.nextPageUrl)) {
            return
        }

        this.unobserve()
        this.blacklist.push(this.nextPageUrl)

        fetch(this.nextPageUrl, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .catch(() => {
                this.observe()
            })
            .then(response => {
               return response.text()
            }).then(this.addPage.bind(this))

    }

    addPage(html)
    {
        this.currentPage++
        this.pagesTarget.insertAdjacentHTML( 'beforeend', html );

        if (!this.nextPage) {
            this.tearDown()
        } else {
            this.observe()
        }
    }


    disconnect()
    {
        this.tearDown()
    }

    tearDown() {
        if (this.triggerTarget) {
            this.triggerTarget.classList.add('d-none')
        }
        this.observer.disconnect()
    }
}
